<template>
  <v-dialog
    v-model="showDialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="px-5"
        v-bind="attrs"
        v-on="on"
        outlined
        small
        @click="showDialog = true"
        style="text-transform: none;"
      >
        <v-icon left>mdi-plus</v-icon>
        {{
          userTags.length > 0
          ? $t("seeTags")
          : $t("addTag")
        }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-toolbar-title>
          {{ userTags.length > 0 ? $t("playerTags") : $t("addTag") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <div
          class="text-subtitle-1 pa-0 mt-6 mb-2"
          :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
        >{{
          userTags.length > 0
            ? $t("tipRemoveTag")
            : $t("tipSelectMaxTags", { maxQtyPlayerTags: maxQtyPlayerTags })
        }}</div>

        <div
          class="d-flex flex-wrap mb-4 scroll"
          style="min-height: 82px; max-height: 118px;"
        >
          <div
            v-for="(tag, index) in currentUserTags"
            :key="index"
            class="rounded-pill py-1 px-3 mr-2 mb-2 d-flex align-center"
            @click="removeTag(tag)"
            style="
              width: fit-content;
              height: min-content;
              white-space: nowrap;
              cursor: pointer;
            "
            :style="{
              'background-color': tag.color + '80',
              'color': 'white',
              'border': '2px solid ' + tag.color,
            }"
          >
            {{ tag.title }}

            <v-icon class="ml-2" small>mdi-close</v-icon>
          </div>
        </div>

        <div
          class="text-subtitle-1 pa-0 mt-6 mb-2 d-flex"
          :class="[
            $vuetify.theme.dark ? 'white--text' : 'black--text',
            $vuetify.breakpoint.width < 425
              ? 'flex-column'
              : 'justify-space-between',
          ]"
        >
          {{ $t("addTags") }}

          <span
            v-if="currentUserTags.length == maxQtyPlayerTags"
            class="grey--text"
          >
            {{ $t("maxTagsReached") }}
          </span>
        </div>

        <div
          class="d-flex flex-wrap mb-4 scroll"
          style="min-height: 84px; max-height: 208px;"
        >
          <div v-if="currentListTags.length == 0">
            {{ $t("noTagsAvailable") }}
          </div>

          <div
            v-else
            v-for="(tag, index) in currentListTags"
            :key="index"
            class="rounded-pill py-1 px-3 mr-2 mb-2 d-flex align-center"
            @click="currentUserTags.length != maxQtyPlayerTags && addTag(tag)"
            style="
              width: fit-content;
              height: min-content;
              white-space: nowrap;
            "
            :style="{
              cursor: currentUserTags.length < maxQtyPlayerTags
                ? 'pointer'
                : 'default',
              'background-color': currentUserTags.length == maxQtyPlayerTags
                ? '#96969680'
                : tag.color + '80',
              'color': 'white',
              'border': currentUserTags.length == maxQtyPlayerTags
                ? '2px solid #969696'
                : '2px solid ' + tag.color,
            }"
          >
            {{ tag.title }}
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pa-6">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          :disabled="isLoading"
          @click="closeDialog"
          style="text-transform: none;"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          class="px-7 ml-4"
          color="primary"
          :loading="isLoading"
          v-on:click.prevent="addOrRemoveTags"
          type="submit"
          :disabled="noActionAddOrRemoveTags || isLoading"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AddOrRemoveTag",

  props: ["userId", "userTags", "listTags"],

  data: () => ({
    showDialog: false,
    isLoading: false,
    maxQtyPlayerTags: 5,
    currentUserTags: [],
    currentListTags: [],
  }),

  mounted() {
    this.showDialog = false;
  },

  watch: {
    showDialog(showDialog) {
      if (showDialog) {
        this.currentUserTags = [];
        this.currentListTags = [];

        this.currentUserTags.push(...this.userTags);
        this.currentListTags.push(...this.listTags);
      }
    },
    userTags(userTags) {
      this.currentUserTags = [];
      this.currentUserTags.push(...userTags);
    },
    listTags(listTags) {
      this.currentListTags = [];
      this.currentListTags.push(...listTags);
    },
  },

  computed: {
    noActionAddOrRemoveTags() {
      if (this.currentUserTags.length !== this.userTags.length) return false;

      let noAction = true;

      this.currentUserTags.forEach((currentUserTag) => {
        if (!noAction) return;

        const findNewTag = this.userTags
          .find((userTag) => currentUserTag.id == userTag.id);

        noAction = !!findNewTag;
      })

      return noAction;
    },
  },

  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    addTag(currentTag) {
      this.currentListTags = this.currentListTags
        .filter((tag) => tag.id !== currentTag.id);

      this.currentUserTags.push(currentTag);
    },
    removeTag(currentTag) {
      this.currentUserTags = this.currentUserTags
        .filter((tag) => tag.id !== currentTag.id);

      this.currentListTags.push(currentTag);
    },
    addOrRemoveTags() {
      this.isLoading = true;
      this.isDisabledSaveBtn = true;

      const selectedIdTags = this.currentUserTags.map((tag) => tag.id);

      this.$axios.post(`${this.$prefix()}/players/updateTagsFromUser`, {
        tag_ids: selectedIdTags,
        user_id: this.userId,
      })
      .then((res) => {
        this.$store.commit("setFeedbackSnack", {
          msg: res.data.messages,
          color: "success",
        });

        this.emitUpdateUserListTags();
      })
      .finally(() => {
        this.isLoading = false;
        this.isDisabledSaveBtn = false;
      });
    },
    emitUpdateUserListTags() {
      this.$emit("updateUserListTags");

      this.closeDialog();
    },
  },
}
</script>

<style scoped>
.scroll {
  overflow-y: auto;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}
</style>